import React, { useMemo } from 'react';
import _get from 'lodash/get';

import { UiKit } from 'components';
import Reason from './Reason';
import { useRequestReasonList } from '../context';
import * as RequestReasonConfig from '../../RequestReasonConfig';
import { ReactComponent as PlusIcon } from 'assets/ss-icons/plus.svg';

export default function List() {
  const { reasons, onReload } = useRequestReasonList();

  const reasonsList = useMemo(() => {
    return reasons.map(data => {
      const id = _get(data, 'id');
      return <Reason key={id} data={data} />;
    });
  }, [reasons]);

  return (
    <UiKit.Flex direction="column" gap={40}>
      <UiKit.Flex direction="column" gap={12}>
        {reasonsList}
      </UiKit.Flex>
      <RequestReasonConfig.Provider onSaved={onReload}>
        <RequestReasonConfig.Form />
        <RequestReasonConfig.Trigger className="mr-auto">
          <PlusIcon />
          Create New Reason
        </RequestReasonConfig.Trigger>
      </RequestReasonConfig.Provider>
    </UiKit.Flex>
  );
}
